import axios from "axios"

const API = axios.create({ baseURL: '/api/vendors' })

//Vendor Crud
export const createVendor = (newVendor) => API.post('/', newVendor)
export const readVendors = () => API.get('/')
export const updateVendor = (id, updatedVendor) => API.patch(`/${id}`, updatedVendor)
export const deleteVendor = (id) => API.delete(`/${id}`)